export enum ProsecutionReviewStage {
	None = 0,
	Supervisor = 1,
	Director = 2,
	Minister = 3,
}
